import { render, staticRenderFns } from "./PCTeam.vue?vue&type=template&id=0a42daf0&scoped=true&lang=pug&"
import script from "./PCTeam.vue?vue&type=script&lang=js&"
export * from "./PCTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42daf0",
  null
  
)

export default component.exports